import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import SummaryQuestions from "js/views/app/summary/summary-questions";
import events from "js/events";
import { questionShape } from "lib/propTypes";
import initJQuery from "lib/vendor/jquery";
import { candidateSetAutoApply } from "redux/candidate/actions";

class ApplicationSummaryQuestions extends React.PureComponent {
    static propTypes = {
        answerCount: PropTypes.number.isRequired,
        autoApplyEnabled: PropTypes.bool,
        candidateSetAutoApply: PropTypes.func.isRequired,
        questions: PropTypes.arrayOf(questionShape).isRequired,
        showJobAlertsPromo: PropTypes.bool.isRequired,
        submittedCount: PropTypes.number.isRequired,
        phone: PropTypes.string.isRequired,
    };

    static defaultProps = {
        autoApplyEnabled: null,
    };

    componentDidMount() {
        const {
            answerCount,
            autoApplyEnabled,
            showJobAlertsPromo,
            submittedCount,
            questions,
            phone,
        } = this.props;

        initJQuery();

        new SummaryQuestions({
            el: this.container,

            answerCount,
            autoApplyEnabled,
            showJobAlertsPromo,
            confirmCount: submittedCount,
            questions,
            phone,

            handleAutoApplyChange: this.handleAutoApplyChange,
        }).render();

        events.trackStep("SUMMARY_QUESTIONS");
    }

    handleAutoApplyChange = (autoApplyEnabled) => {
        this.props.candidateSetAutoApply(autoApplyEnabled);
    };

    render() {
        return <div className="app-summary__questions" ref={(c) => (this.container = c)} />;
    }
}

export default connect(null, { candidateSetAutoApply })(ApplicationSummaryQuestions);
